import { ISODateString } from "@smartrr/shared/entities/ISODateString";
import { useActiveOrganizationSelector } from "@vendor-app/app/_state/reducers/organizations";

import { DateTime } from "luxon";

export const useFormatDateTime = () => {
  const organization = useActiveOrganizationSelector();
  return (date: ISODateString) => {
    const day = ISODateString.fromString(date).setZone(organization?.billingTimezone);
    const formattedDay = day.toLocaleString(DateTime.DATE_FULL);
    const time = day.toLocaleString({
      hour: "2-digit",
      minute: "2-digit",
    });
    return [formattedDay, time];
  };
};
